
const _colors = {
  PURE_WHITE: '#FFFFFF',
  WHITE:      '#F2F2F2',
  DARK_GRAY:  '#626262',
  GARY_BLACK: '#4F4F4F',
  BLACK:      '#333333',
  BLUE:       '#2D9CDB',
  DARK_BLUE:  '#2C3241',
  BLUE_GRAY:  '#3D4656',
  RED:        '#EB5757',
  GRAY:       '#828282',
  YELLOW:     '#F6FB06',
  LIGHT_BLUE: '#56CCF2',
  SLIGHTLY_GRAY: '#BDBDBD',
  LIGHT_GRAY: '#E2E2E2',
  PINK:       '#FA678A',
}


export default {
  data() {
    return {
      AISEA_COLOR: _colors,
    };
  },
  methods: {}
};
